import ChevronDownIcon from "../images/ChevronDownIcon.mjs";

/**
 * App icon representing zoom level decreasing
 * @see {GlyphIcon}
 * @see {ChevronDownIcon}
 */
const AppZoomOutIcon = class extends ChevronDownIcon {};

export default AppZoomOutIcon;